import {ContentItemType, SingleResponseQuestionWidget} from '@ael/core-api';

export enum QuestionWidgetTrackingActions {
  SetSelectedOption = 'SetSelectedOption',
  ResetSelectedOption = 'ResetSelectedOption',
}

export const setSelectedOption = (
  contentItem: ContentItemType,
  questionWidget: SingleResponseQuestionWidget,
  selectedOption: number
) => ({
  type: QuestionWidgetTrackingActions.SetSelectedOption,
  payload: {
    contentItem,
    questionWidget,
    selectedOption,
  },
});
export const resetSelectedOption = (contentItem: ContentItemType, questionWidget: SingleResponseQuestionWidget) => ({
  type: QuestionWidgetTrackingActions.ResetSelectedOption,
  payload: {
    contentItem,
    questionWidget,
  },
});
